<template>
  <div>
    <div class="row mb-3">
      <div class="col-lg-3">
        <input
          type="text"
          v-model="keywords"
          v-on:keydown.enter="search()"
          placeholder="Search in documents title..."
        />
      </div>
      <div class="col-lg-3">
        <div class="select-style">
          <select class="mb-0" v-model="doc_cat_parent" @change="search(true)">
            <option value="">All top categories</option>
            <option
              v-for="docs_parent_cat in dataDocsCats"
              :value="docs_parent_cat.id" v-if="!docs_parent_cat.parent_id && (docs_parent_cat.children.length || docs_parent_cat.documents.length)"
            >
              {{ docs_parent_cat.name }}
            </option>
          </select>
        </div>
      </div>
      <div v-if="docs_child_cats.length" class="col-lg-3">
        <div class="select-style">
          <select class="mb-0" v-model="doc_cat_child" @change="search()">
            <option value="">All sub categories</option>
            <option
              v-for="docs_child_cat in docs_child_cats"
              v-if="docs_child_cat.documents.length"
              :value="docs_child_cat.id"
            >
              {{ docs_child_cat.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col">
        <button
          class="btn btn-medium btn-transparent-black"
          v-on:click="search()"
        >
          Search
        </button>
        <button
          v-if="doc_cat_child || doc_cat_parent || keywords"
          class="btn btn-small px-0"
          v-on:click="reset()"
        >
          <i class="fas fa-sync-alt"></i> Reset
        </button>
      </div>
    </div>
    <div v-if="docs_cats.length">
      <div
        v-for="(docs_parent_cat, i) in docs_cats"
        v-if="
          docs_parent_cat.parent_id == null &&
          (docs_parent_cat.documents.length || docs_parent_cat.children.length)
        "
        class="border my-2"
      >
        <div
          class="accordion-title font-weight-bold text-uppercase p-3 bg-light-gray cursor-pointer"
        >
          {{ docs_parent_cat.name }}
          <span class="float-right"><i class="fas fa-chevron-down"></i></span>
        </div>
        <div class="accordion-body parent-cat p-3">
          <div
            class="py-1"
            v-for="doc in docs_parent_cat.documents"
            v-if="!doc_cat_child"
          >
            <a :href="doc.file" target="_blank"
              ><i class="fas fa-download"></i>
              <span class="text-underline">{{ doc.name }}</span></a
            >
          </div>
          <div
            v-if="docs_child_cat.documents.length"
            v-for="docs_child_cat in docs_parent_cat.children"
          >
            <div
              class="accordion-title cursor-pointer font-weight-bold border-bottom py-2 mb-2"
            >
              {{ docs_child_cat.name }}
              <span class="float-right"
                ><i class="fas fa-chevron-down"></i
              ></span>
            </div>
            <div class="accordion-body sub-cat">
              <div class="ml-4 py-1" v-for="doc in docs_child_cat.documents">
                <a :href="doc.file" target="_blank"
                  ><i class="fas fa-download"></i>
                  <span class="text-underline">{{ doc.name }}</span></a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="alert alert-secondary">
      No document match with your search...
    </div>
  </div>
</template>

<script>
$(document).on("click", ".accordion-title", function () {
  $(this).next().slideToggle();
});
export default {
  props: ["dataDocsCats"],
  data() {
    return {
      docs_cats: this.dataDocsCats,
      docs_child_cats: [],
      keywords: null,
      doc_cat_parent: "",
      doc_cat_child: "",
    };
  },
  computed: {},
  watch: {
    'docs_cats': function (val, oldVal) {
        console.log('changed')
      if (this.doc_cat_child || this.keywords) {
        $(".accordion-body").show();
      } else {
        $(".accordion-body.parent-cat").show();
      }
    },
  },
  methods: {
    reset() {
      this.doc_cat_child = "";
      this.doc_cat_parent = "";
      this.keywords = "";
      this.docs_child_cats = [];
      this.search(false, true);
    },
    search(is_parent) {
      if (is_parent) {
        this.doc_cat_child = "";
      }
      axios
        .post("search", {
          keywords: this.keywords,
          doc_cat_parent: this.doc_cat_parent,
          doc_cat_child: this.doc_cat_child,
        })
        .catch((error) => {})
        .then((response) => {
          if (response.data) {
            $(".accordion-body").hide();
            this.docs_cats = response.data;
            if (is_parent) {
              if (this.doc_cat_parent) {
                this.docs_child_cats = this.docs_cats[0].children;
              } else {
                this.docs_child_cats = [];
              }
            }
          }
        });
    },
    expand: function (e, i) {},
  },
};
</script>
